import { render } from "./PropertiesChart.vue?vue&type=template&id=6ae2f904&ts=true"
import script from "./PropertiesChart.vue?vue&type=script&lang=ts"
export * from "./PropertiesChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__